module.exports = __webpack_public_path__ + "static/media/soaringstallion.8824358e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/soaringstallion.png
// module id = 1372
// module chunks = 1